import Sentry from '@/shared/lib/sentry'
import { download } from '@/shared/tools/report'

export async function downloadProductsImportTemplate(columns: string[]) {
	try {
		const Excel = await import('exceljs')
		const workbook = new Excel.Workbook()
		workbook.creator = 'Competera'
		const worksheet = workbook.addWorksheet('Sheet1')
		worksheet.columns = columns.map((key) => ({
			header: key,
			key,
			width: 20,
			outlineLevel: 1,
		}))
		const buffer = await workbook.xlsx.writeBuffer()
		const blob = new Blob([buffer], {
			type: 'application/octet-binary;charset=utf-8',
		})
		download(blob, 'import_template.xlsx')
	} catch (error) {
		Sentry.captureException(error)
	}
}
export async function readFileHeaders(file: File) {
	try {
		const reader = new FileReader()
		if (file.type === 'text/csv') {
			return new Promise((resolve, reject) => {
				reader.onload = () => {
					if (typeof reader.result === 'string') {
						const firstRow = reader.result.split('\n')[0]
						resolve(firstRow?.split(';') || [])
					} else {
						reject(new Error('Invalid file content'))
					}
				}
				reader.readAsText(file)
			})
		} else {
			const Excel = await import('exceljs')
			const workbook = new Excel.Workbook()

			return new Promise((resolve) => {
				reader.onload = () => {
					const buffer = reader.result
					workbook.xlsx
						.load(buffer as ArrayBuffer)
						.then((workbook) =>
							resolve(workbook.worksheets[0].getRow(1).values as string[])
						)
				}
				reader.readAsArrayBuffer(file)
			})
		}
	} catch (error) {
		Sentry.captureException(error)
	}
}
export async function readXlsxFile(file: File) {
	try {
		const Excel = await import('exceljs')
		const workbook = new Excel.Workbook()
		const reader = new FileReader()

		return new Promise((resolve) => {
			reader.readAsArrayBuffer(file)
			reader.onload = () => {
				const buffer = reader.result
				workbook.xlsx
					.load(buffer as ArrayBuffer)
					.then((workbook) =>
						resolve(workbook.worksheets[0].getRow(1).values as string[])
					)
			}
		})
	} catch (error) {
		Sentry.captureException(error)
	}
}
